import styled from "styled-components";
import { Label } from "../editor/EditorHelpers";

const RadioWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StyledRadio = styled.input`
  width: 18px;
  height: 18px;
  margin-right: 10px;
  accent-color: var(--link-color);
  outline: none;
  transition: border-color 0.2s;
  transform: translateY(-1px);

  &:focus {
    outline: 1px solid var(--link-color);
    border-radius: 0.125rem;
  }
`;

const RadioLabel = styled.label`
  font-size: 1em;
  color: var(--text-color);

  a {
    color: var(--link-color);
    text-decoration: none;
    transition: color 0.2s;

    &:hover {
      color: var(--text-color);
    }
  }
`;

interface RadioButtonProps {
  id: string;
  value: string;
  checked: boolean;
  onChange: (value: string) => void;
  label: string;
}

const RadioButton: React.FC<RadioButtonProps> = ({
  id,
  value,
  checked,
  onChange,
  label,
}) => {
  return (
    <RadioWrapper>
      <StyledRadio
        type="radio"
        value={value}
        checked={checked}
        onChange={() => onChange(value)}
        id={id}
      />
      <RadioLabel htmlFor={id}>{label}</RadioLabel>
    </RadioWrapper>
  );
};

interface RadioGroupProps {
  options: { id: string; value: string; label: string }[];
  selectedValue: string;
  onChange: (value: string) => void;
  label?: string;
}

const RadioGroup: React.FC<RadioGroupProps> = ({ options, selectedValue, onChange, label }) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '5px',
    }}>
      {!!label && <Label>{label}</Label>}
      {options.map((option) => (
        <RadioButton
          key={option.id}
          id={option.id}
          value={option.value}
          checked={selectedValue === option.value}
          onChange={onChange}
          label={option.label}
        />
      ))}
    </div>
  );
};

export default RadioGroup;
